import "./SubMenuListComponent.scss";
import {ISubMenuItem} from "../../models/menu.model";
import {NavLink} from "react-router-dom";
import {CommonService} from "../../services";
import {ImageConfig} from "../../../constants";

interface SubMenuListComponentProps {
    menuItems: ISubMenuItem[]
}

const SubMenuListComponent = (props: SubMenuListComponentProps) => {

    const {menuItems, ...otherProps} = props;

    return (
        <div className={'sub-menu-list-component'}>
            <div className="sub-menu-wrapper">
                <div className="sub-menu">
                    {
                        menuItems.map((item) => {
                            if (item.path) {
                                return (
                                    <NavLink
                                        id={`${item.title.toLowerCase().split(' ').join('_')}_menu`}
                                        to={{
                                            pathname: item.path,
                                        }}
                                        key={item.title}
                                        className="sub-menu-item"
                                        state={{title: item.title}}
                                        {...otherProps}
                                        // This adds an "active" class when the NavLink is selected
                                    >
                                        {({isActive}) => (
                                            <>
                                                {isActive ? <span className={'sub-menu-title'}>
                                                    <span className="menu-icon">
                                                <ImageConfig.SideArrowIcon/>
                                            </span>
                                                    <span>{item.title}</span>
                                                </span> : <span>{item.title}</span>
                                                }
                                            </>
                                        )}
                                    </NavLink>
                                )
                            } else {
                                return (
                                    <div
                                        id={`${item.title.toLowerCase().split(' ').join('_')}_menu`}
                                        onClick={() => {
                                            CommonService._alert.showToast('Coming Soon');
                                        }}
                                        key={item.title}
                                        className="sub-menu-item"
                                    >
                                        {item.title}
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        </div>);

};

export default SubMenuListComponent;
